import request from '../../axios';
import {IPostCreditStoreOrderTransactionPayload} from '../postCreateCreditStoreOrderTransaction/postCreateCreditStoreOrderTransaction';

const postCreateCashBackStoreOrderTransaction = async (
  payload: IPostCreditStoreOrderTransactionPayload,
) => {
  const data = await request.post(
    `api/v2/payment/create-store-order-transaction-with-cashback`,
    payload,
  );

  return data;
};

export default postCreateCashBackStoreOrderTransaction;
